export const GET_AUTHOR_DASHBOARD_REQUEST = "GET_AUTHOR_DASHBOARD_REQUEST";
export const GET_AUTHOR_DASHBOARD_SUCCESS = "GET_AUTHOR_DASHBOARD_SUCCESS";
export const GET_AUTHOR_DASHBOARD_FAILURE = "GET_AUTHOR_DASHBOARD_FAILURE";

export const GET_AUTHOR_EARNINGS_REQUEST = "GET_AUTHOR_EARNINGS_REQUEST";
export const GET_AUTHOR_EARNINGS_SUCCESS = "GET_AUTHOR_EARNINGS_SUCCESS";
export const GET_AUTHOR_EARNINGS_FAILURE = "GET_AUTHOR_EARNINGS_FAILURE";

export const GET_AUTHOR_PAYOUTS_REQUEST = "GET_AUTHOR_PAYOUTS_REQUEST";
export const GET_AUTHOR_PAYOUTS_SUCCESS = "GET_AUTHOR_PAYOUTS_SUCCESS";
export const GET_AUTHOR_PAYOUTS_FAILURE = "GET_AUTHOR_PAYOUTS_FAILURE";

export const REQUEST_PAYOUT_REQUEST = "REQUEST_PAYOUT_REQUEST";
export const REQUEST_PAYOUT_SUCCESS = "REQUEST_PAYOUT_SUCCESS";
export const REQUEST_PAYOUT_FAILURE = "REQUEST_PAYOUT_FAILURE";

export const GET_PAYOUT_SETTINGS_REQUEST = "GET_PAYOUT_SETTINGS_REQUEST";
export const GET_PAYOUT_SETTINGS_SUCCESS = "GET_PAYOUT_SETTINGS_SUCCESS";
export const GET_PAYOUT_SETTINGS_FAILURE = "GET_PAYOUT_SETTINGS_FAILURE";

export const GET_BOOK_PERFORMANCE_REQUEST = "GET_BOOK_PERFORMANCE_REQUEST";
export const GET_BOOK_PERFORMANCE_SUCCESS = "GET_BOOK_PERFORMANCE_SUCCESS";
export const GET_BOOK_PERFORMANCE_FAILURE = "GET_BOOK_PERFORMANCE_FAILURE";
